import React from "react";
import numeral from "numeral";

import { injectIntl, FormattedMessage } from "react-intl";
import { Button } from "@ts-digital/vrc";

import WidgetCard from "./card";
import imgWidgetIncassaSubito from "../../assets/img/imgWidgetIncassaSubito.svg";
import incassaSubito1 from "../../assets/img/incassaSubito1.svg";
import { COMMON_LOGIN_URL } from "../../config";

const WidgetIncassaSubito = props => {
  const { incassaSubito, clientIdSelected } = props;

  function formatNumber(number) {
    return numeral(Math.abs(number)).format("0,0.00");
  }
  function renderFooter() {
    const isActive =
      incassaSubito.privacy &&
      incassaSubito.privacy.data &&
      incassaSubito.privacy.data.agyoServiceActive === true;

    /* const link =
      TSDIGITAL_PORTALE_PUBLIC_URL +
      "#/" +
      clientIdSelected +
      "/apps/invoice-trading";*/
      
    const link = `${COMMON_LOGIN_URL}/?mode=redirect&appId=PORTALE&deepLink=/${clientIdSelected}/apps/invoice-trading`;

    return (
      <div style={{ textAlign: "right" }}>
        {!isActive ? (
          <div
            style={{
              display: "flex",
              margin: "20px",
              justifyContent: "space-between"
            }}
          >
            <Button
              style={{ background: "transparent", color: "white" }}
              kind={"secondary"}
              colorScheme={"alert"}
              onClick={() => {
                if (window.aptrinsic) {
                  window.aptrinsic("track", "digital-box:INCASSA-SUBITO");
                }
              }}
            >
              <FormattedMessage id="dashboard.showVideo" />
            </Button>

            <a
              href={"https://digitalfinance.teamsystem.com/incassa-subito"}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                style={{ background: "transparent", color: "white" }}
                kind={"secondary"}
                colorScheme={"alert"}
              >
                <FormattedMessage id="dashboard.showMore" />
              </Button>
            </a>
          </div>
        ) : (
          <a href={link} target="_blank" rel="noopener noreferrer">
            <Button>
              {" "}
              <FormattedMessage id="dashboard.goToIncassaSubito" />
            </Button>
          </a>
        )}
      </div>
    );
  }

  if (
    incassaSubito &&
    incassaSubito.privacy &&
    incassaSubito.totalEligibleInvoices &&
    incassaSubito.privacy.data &&
    incassaSubito.totalEligibleInvoices.data
  ) {
    return (
      <WidgetCard
        type={"box1_3"}
        background={!incassaSubito.privacy.data.agyoServiceActive}
        titleWidget={
          incassaSubito.privacy.data.agyoServiceActive ? (
            <div>
              <div
                style={{
                  width: "50%",
                  display: "inline-block",
                  marginTop: 13
                }}
              >
                <FormattedMessage id="dashboard.incassaSubito" />
              </div>
            </div>
          ) : null
        }
        footer={renderFooter()}
      >
        {!incassaSubito.privacy.data.agyoServiceActive && (
          <div>
            <div className="img2">
              <img src={incassaSubito1} alt="Teamsystem Digital" />
            </div>
            <div className="subTitle4">INCASSA SUBITO </div>
            <div className="subTitle1 white">
              Vuoi incassare in anticipo fino al 90% dell’importo delle tue
              fatture?{" "}
            </div>
            <div className="subTitle2 white">
              Chiedi al tuo consulente di attivare il nuovo servizio TeamSystem.
            </div>
          </div>
        )}
        {incassaSubito.privacy.data.agyoServiceActive &&
          incassaSubito.totalEligibleInvoices.data.count === 0 && (
          <div>
            <div className="subTitle1">
                Non hai ancora fatture eleggibili.{" "}
            </div>
            <div className="subTitle2">
                Vuoi sapere in tempo reale quando avrai fatture eleggibili?
                Attiva il servizio di <b>invio automatico</b> nelle impostazioni
                di Incassa Subito.
            </div>
            <div className="img">
              <img src={imgWidgetIncassaSubito} alt="Teamsystem Digital" />
            </div>
          </div>
        )}
        {incassaSubito.privacy.data.agyoServiceActive &&
          incassaSubito.totalEligibleInvoices.data.count !== 0 && (
          <div>
            <div className="subTitle3">
                Hai{" "}
              <b style={{ fontSize: "24px" }}>
                {incassaSubito.totalEligibleInvoices.data.count}{" "}
              </b>
              {incassaSubito.totalEligibleInvoices.data.count === 1
                ? "fattura eleggibile "
                : "fatture eleggibili "}
                alla cessione.
            </div>
            <div className="subTitle3">
                In 48 ore potresti ricevere un acconto di{" "}
              <div>
                <b style={{ fontSize: "24px" }}>
                  {formatNumber(incassaSubito.totalEligibleInvoices.data
                    .totalDownPaymentAmount)}{" "}
                    €
                </b>{" "}
              </div>
            </div>
          </div>
        )}
      </WidgetCard>
    );
  } return null;
};

export default injectIntl(WidgetIncassaSubito);
